import { Dispatch, SetStateAction } from 'react';
import { t } from 'i18next';
import { UseFormSetValue } from 'react-hook-form';
import { fileServiceUploadFeedback, UserFeedbackRequest, userServicePostFeedback } from '@/api';
import { toast } from 'react-toastify';
import { convertBlob } from '@shared/utils';

export type FileWithURL = File & {
    urlFile?: string;
};

type Props = {
    files: FileWithURL[];
    setFiles: Dispatch<SetStateAction<FileWithURL[]>>;
    setErrorUpload: Dispatch<SetStateAction<string>>;
    setError: (error: boolean) => void;
    setUploading: (uploading: boolean) => void;
    setValue: UseFormSetValue<UserFeedbackRequest>;
    setIsSuccess: (isSuccess: boolean) => void;
};

export const useChangeSubmitFeedback = ({
    files,
    setFiles,
    setError,
    setErrorUpload,
    setUploading,
    setValue,
    setIsSuccess,
}: Props) => {
    const errorList: string[] = [];
    const errorList413: string[] = [];
    const onSubmit = (data: UserFeedbackRequest) => {
        setUploading(true);
        Promise.all(
            files.map(async (file) => {
                if (file.urlFile) return file;
                else {
                    return fileServiceUploadFeedback({ body: { content: await convertBlob(file) } })
                        .then((res) => {
                            if (res?.error) throw res?.error;
                            file.urlFile = res?.data?.filename;
                            return file;
                        })
                        .catch((e) => {
                            e.status === 413 ? errorList413.push(file.name) : errorList.push(file.name);
                            return file;
                        });
                }
            })
        ).then((updatedFiles) => {
            setFiles(updatedFiles);
            setError(false);
            setErrorUpload('');
            if (errorList.length || errorList413.length) {
                errorList413.length && setErrorUpload(`${errorList413.join(' ')} ${t('feedbackErrorUploadTooLarge')}`);
                errorList.length &&
                    setErrorUpload((prev) => `${prev} ${errorList.join(' ')} ${t('feedbackErrorUpload')}`);
                setUploading(false);
                return;
            }
            data.attachments = updatedFiles.map((file) => file.urlFile || '');
            userServicePostFeedback({ body: data })
                .then((resp) => {
                    if (resp?.error) return toast.error(resp?.error.message);
                    setFiles([]);
                    setValue('message', '');
                    setIsSuccess(true);
                    setError(false);
                })
                .catch(() => {
                    setError(true);
                })
                .finally(() => {
                    setUploading(false);
                });
        });
    };

    return {
        onSubmit,
    };
};
